<template>
  <div>
    <div v-if="otp === false">
      <div
        class="row"
        style="
          margin-top: 18%;
          margin-bottom: 20%;
          margin-right: 3%;
          margin-left: 3%;
        "
      >
        <div class="col-sm-1 col-md-3"></div>
        <div class="col-md-6 col-sm-10">
          <form>
            <div class="form-group">
              <input
                class="mobile"
                id="mobile"
                maxlength="10"
                placeholder="Enter mobile number"
                style="width: 100%"
                v-on:keyup.enter="signup()"
                required
              />
              <hr
                style="
                  display: block;
                  height: 1px;
                  border: 0;
                  border-top: 1px solid #3cb6c3;
                  margin: 0em 0%;
                  padding: 0;
                "
              />
            </div>
            <div class="w3-center">
              <input
                class="regbutton"
                value="NEXT"
                type="button"
                v-on:click="signup()"
                style="width: 100%"
              />
            </div>
          </form>
        </div>
        <div class="col-sm-1 col-md-3"></div>
      </div>
    </div>

    <div v-if="otp">
      <div
        class="row"
        style="
          margin-top: 18%;
          margin-bottom: 20%;
          margin-right: 3%;
          margin-left: 3%;
        "
      >
        <div class="col-sm-1 col-md-3"></div>
        <div class="col-md-6 col-sm-10">
          <form>
            <div class="form-group">
              <input
                class="mobile"
                id="mobile"
                maxlength="10"
                v-model="signUp.disMobile"
                disabled="true"
              />
              <hr
                style="
                  display: block;
                  height: 1px;
                  border: 0;
                  border-top: 1px solid #3cb6c3;
                  margin: 0em 0%;
                  padding: 0;
                "
              />
            </div>
            <div class="form-group">
              <input
                class="mobile"
                id="otp"
                maxlength="4"
                placeholder="Enter OTP"
                v-on:keyup.enter="verifyotp()"
                required
              />
              <hr
                style="
                  display: block;
                  height: 1px;
                  border: 0;
                  border-top: 1px solid #3cb6c3;
                  margin: 0em 0%;
                  padding: 0;
                "
              />
            </div>
            <div class="w3-center">
              <input
                class="regbutton"
                value="REGISTER"
                type="button"
                v-on:click="verifyotp()"
                style="width: 100%"
              />
            </div>
            <div
              style="
                color: #11a4e0;
                margin-top: 2%;
                margin-bottom: 2%;
                text-align: center;
              "
            >
              If you do not receive your OTP within 1 minute, click the Resend
              Otp button to resend otp
            </div>
            <div class="w3-center">
              <input
                class="regbutton"
                value="RESEND OTP"
                type="button"
                v-on:click="resendotp()"
                style="width: 100%"
              />
            </div>
          </form>
        </div>
        <div class="col-sm-1 col-md-3"></div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      signUp: [],
      resendOtp: [],
      verifyOtp: [],
      otp: false,
    };
  },

  created() {
    var userId = sessionStorage.getItem("userId");
    var productListUrl = sessionStorage.getItem("productListUrl");
    if (userId && productListUrl) {
      window.location.href = productListUrl;
    } else {
      sessionStorage.clear();
    }
  },

  methods: {
    signup() {
      const params = new URLSearchParams();
      var mobile = document.getElementById("mobile").value;
      var deviceID = document.getElementById("mobile").value;
      if (isNaN(mobile) || mobile.length !== 10 || mobile === "") {
        alert("Oops! Invalid Mobile Number.");
      } else {
        params.append("mobile", mobile);
        params.append("deviceId", deviceID);
        axios({
          url: process.env.BASE_API + "/users/signup",
          method: "post",
          data: params,
          withCredentials: false,
          headers: {},
        })
          .then((response) => {
            this.signUp = {};
            if (
              response.data.status === "000000" ||
              response.data.status === "000001" ||
              response.data.status === "000002" ||
              response.data.status === "000007" ||
              response.data.status === "000012"
            ) {
              this.signUp.disMobile = mobile;
              this.otp = true;
              if (
                response.data.status === "000000" &&
                response.data.is_profile === 1
              ) {
              } else {
                this.resendotp();
              }
            } else {
              alert(response.data.msg);
            }
            // console.log(response)
            if (response.data.status.trim().toUpperCase() === "SUCCESS") {
              this.list = response.data.user_record;
              // alert(this.list)
            }
          })
          .catch((e) => {
            alert("Please try again!");
          });
      }
    },
    resendotp() {
      const params = new URLSearchParams();
      params.append("mobile", this.signUp.disMobile);
      params.append("deviceId", this.signUp.disMobile);
      axios({
        url: process.env.BASE_API + "/users/resend-otp",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {},
      })
        .then((response) => {
          this.resendOtp = {};
          if (response.data.status !== "000000") {
            alert(response.data.msg);
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === "SUCCESS") {
            this.list = response.data.user_record;
            // alert(this.list)
          }
        })
        .catch((e) => {
          alert("Please try again!");
        });
    },
    verifyotp() {
      const params = new URLSearchParams();
      var otp = document.getElementById("otp").value;
      var mobile = this.signUp.disMobile;
      var deviceID = this.signUp.disMobile;
      if (isNaN(otp) || otp.length !== 4 || otp === "") {
        alert("Oops! Invalid OTP.");
      } else {
        params.append("otp", otp);
        params.append("mobile", mobile);
        params.append("deviceId", deviceID);
        axios({
          url: process.env.BASE_API + "/users/verify-otp",
          method: "post",
          data: params,
          withCredentials: false,
          headers: {},
        })
          .then((response) => {
            this.verifyOtp = {};
            if (response.data.status === "000000") {
              /* this.verifyOtp.userId = response.data.user_id
              this.verifyOtp.roleId = response.data.role_id
              this.verifyOtp.isProfile = response.data.is_profile
              this.verifyOtp.userMobile = response.data.user_mobile */
              sessionStorage.setItem("userId", response.data.user_id);
              sessionStorage.setItem("roleId", response.data.role_id);
              sessionStorage.setItem("isProfile", response.data.is_profile);
              sessionStorage.setItem("userMobile", response.data.user_mobile);
              if (response.data.is_profile === 0) {
                if (
                  sessionStorage.getItem("urlstr") === "undefined" ||
                  sessionStorage.getItem("urlstr") === null
                ) {
                  // this.$router.push('/a/subscription')
                  sessionStorage.setItem(
                    "productListUrl",
                    response.data.product_list_url
                  );
                  window.location.href = response.data.product_list_url;
                  /* var fullUrl = response.data.product_list_url;
                  var splitUrl = fullUrl.split("productList?");
                  // sessionStorage.setItem('productListUrl', 'https://t.doodhvale.in/#/a/productList?' + splitUrl[1])
                  // window.location.href = 'https://t.doodhvale.in/#/a/productList?' + splitUrl[1]
                  sessionStorage.setItem(
                    "productListUrl",
                    "http://localhost:4000/a/productList?" + splitUrl[1]
                  );
                  window.location.href =
                    "http://localhost:4000/a/productList?" + splitUrl[1]; */
                } else {
                  this.$router.push("/a/s?" + sessionStorage.getItem("urlstr"));
                }
              } else {
                this.$router.push("/a/location");
              }
            } else {
              alert(response.data.msg);
            }
            // console.log(response)
            if (response.data.status.trim().toUpperCase() === "SUCCESS") {
              this.list = response.data.user_record;
              // alert(this.list)
            }
          })
          .catch((e) => {
            alert("Please try again!");
          });
      }
    },
  },
};
</script>

<style>
.mobile {
  background-color: transparent;
  border: 0px solid;
  padding-bottom: 1%;
  font-size: 20px;
}
.regbutton {
  background-color: #3cb6c3;
  width: 70%;
  padding: 3% 3% 3% 0%;
}
.icon {
  font-size: xx-large;
  width: 25px;
}
/* hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid #3CB6C3;
    margin: 0em 15%;
    padding: 0; 
} */
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reg.vue